<template>
  <div class="mt5">
    <search-box v-if="showSearch&&searchType===0" @reset-search="baseResetSearch"  @action="loadData" >
      <template v-if="$slots['form-item']||searchList&&searchList.length>0" #form-item>
        <slot name="form-item"></slot>
        <el-form-item v-for="item in searchList" :label="item.label" :key="item.prop" label-width="70px">
          <simple-dict v-if="item.type==='dict'"  style="width:220px" :dict-type="item.dictType" v-model="searchObj[item.prop]" is-all=""></simple-dict>
          <simple-dict v-else-if="item.type==='select'"  style="width:220px" :init-options="item.options" v-model="searchObj[item.prop]" is-all=""></simple-dict>
          <el-date-picker v-else-if="item.type==='date'" style="width:220px" v-model="searchObj[item.prop]" value-format="YYYY-MM-DD" type="date" :placeholder="`请选择${item.label || '未知'}`"/>
          <date-picker v-else-if="item.type==='daterange'" style="width:380px"
                       :start-date="searchObj[item.start]"
                       :end-date="searchObj[item.end]"
                       un-disabled=""
                       @change="changeTimeRange($event,item)"  ></date-picker>
          <el-input v-else="" style="width:220px" v-model="searchObj[item.prop]" :placeholder="`请输入${item.label || '未知'}搜索`"
                    @keyup.enter.native="search()" clearable></el-input>
        </el-form-item>
      </template>
      <slot></slot>
    </search-box>
    <div class="base-btn-box" v-else-if="$slots.default">
      <slot></slot>
      <div v-if="showSearch&&searchType===1"  class="flex flex-1 flex-e">
        <el-form :inline="true">
          <template v-if="$slots['form-item']||searchList&&searchList.length>0" >
            <slot name="form-item"></slot>
            <el-form-item v-for="item in searchList" :label="item.label" :key="item.prop" label-width="70px">
              <simple-dict v-if="item.type==='dict'"  style="width:220px" :dict-type="item.dictType" v-model="searchObj[item.prop]" is-all=""></simple-dict>
              <simple-dict v-else-if="item.type==='select'"  style="width:220px" :init-options="item.options" v-model="searchObj[item.prop]" is-all=""></simple-dict>
              <el-date-picker v-else-if="item.type==='date'" style="width:220px" v-model="searchObj[item.prop]" value-format="YYYY-MM-DD" type="date" :placeholder="`请选择${item.label || '未知'}`"/>
              <date-picker v-else-if="item.type==='daterange'" style="width:380px"
                           :start-date="searchObj[item.start]"
                           :end-date="searchObj[item.end]"
                           un-disabled=""
                           @change="changeTimeRange($event,item)"  ></date-picker>
              <el-input v-else="" style="width:220px" v-model="searchObj[item.prop]" :placeholder="`请输入${item.label || '未知'}搜索`"
                        @keyup.enter.native="search()" clearable></el-input>
            </el-form-item>
          </template>
        </el-form>
        <el-button type="primary" @click="search()" >查询</el-button>
      </div>
    </div>
    <t-table ref="tTable" :data="tableData" :border="true" :header="tableHeader" @selection-change="selectionChange" :op-width="opWidth" :hide-op="hideOp">
      <template #before>
        <slot name="before"></slot>
      </template>
      <template #ext>
        <slot name="ext"></slot>
      </template>
      <template v-if="$slots.op" #default="scope">
        <slot name="op" :row="scope.row" :$index="scope.$index"></slot>
      </template>
    </t-table>
    <page ref="page" :position="position" @handle-page="handlePage"></page>
  </div>
</template>

<script>
import SearchBox from "./SearchBox";
import TTable from "../el/t-table";
import Page from "./page";
import TButton from "../el/t-button";
import BButton from "../el/b-button";
import SimpleDict from "../dict/SimpleDict";
import OneDatePicker from "./OneDatePicker";
import DatePicker from "./DatePicker";

export default {
  props:{
    position:{
      type:String,
      default:"right"
    },
    searchType:{
      type:Number,
      default:0
    },
    placeholder:{
      type:String
    },
    prop:{
      type:Object,
    },
    url:{
      type: String,
      required: true
    },
    tableHeader:{
      type:Array,
      required:true
    },
    /**
     * 搜索拓展
     * expend:[{label:"",prop:"",type:"input|dict|date|daterange"},dictType:"",expendDefault:true]
     */
    expend:{
      type:Array,
      default:[],
    },
    //是否默认加载列表
    initLoad:{
      type:Boolean,
      default:true
    },
    hideOp:{
      type:Boolean,
      default:false
    },
    opWidth:{
      type:Number,
    },
    showSearch:{
      type:Boolean,
      default:true
    }
  },
  name: "page-request",
  components: {DatePicker, OneDatePicker, SimpleDict, BButton, TButton, Page, TTable, SearchBox},
  data() {
    return {
      searchObj:{},
      tableData:[],
      searchList:[],
      defaultSearch:{label:"名称",prop:"name"},
      selectItem:[]
    }
  },
  watch:{
    prop(){
      this.loadData();
    }
  },
  mixins: [tableBase],
  methods: {
    getSelectionRows(){
      return this.selectItem;
    },
    selectionChange(list){
      this.selectItem = list;
    },
    loadData(){
      this.$nextTick(()=>{
        if(this.prop){
          Object.assign(this.searchObj,this.prop)
        }
        this.loadPageData(this.url,null,res=>{
          this.$emit('load',this.searchObj,res.data);
        });

      })
    },
    changeTimeRange(arr,item){
      this.searchObj[item.start] = (arr&&arr[0]||"")  + (arr&&arr[0]?" 00:00:00":"");
      this.searchObj[item.end] = (arr&&arr[1]||"") + (arr&&arr[1]?" 23:59:59":"");
    },
    search(obj){
      Object.assign(this.searchObj,obj)
      this.loadData();
    },
    setSearch(row){
      if(row.type==='daterange'){
        this.searchObj[row.start] = "";
        this.searchObj[row.end] = "";
      }else{
        //this.searchObj[row.prop] = "";
        this.searchObj[row.prop] = "";
      }
    },
    getSearchObj(){
      return this.searchObj;
    }
  },
  mounted() {
    this.searchList = [];
    this.searchObj ={};
    this.tableHeader&&this.tableHeader.forEach(row=>{
      if(row.expendDefault){
        this.setSearch(row);
        this.defaultSearch = {label:row.label,prop:row.prop};
      }else if(row.expend){
        this.setSearch(row);
        this.searchList.push({label:row.label,prop:row.prop});
      }
    })
    this.expend&&this.expend.forEach(row=>{
      this.setSearch(row);
      if(row.expendDefault){
        this.defaultSearch = row;
      }else{
        this.searchList.push(row);
      }
    })
    this.initLoad&&this.loadData();
  }
}
</script>

<style lang="less" scoped>
.el-form-item .el-form-item{
  margin-bottom: 18px !important;
}
.base-btn-box{
  display: flex;
  align-items: center;
}
</style>
